






























































































































import { Component, Vue} from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import GarageDetails from '@/components/GarageDetails.vue';
import { DropDownItem } from "@/services/DropDownItem";
import SearchFilter from '@/components/Utilities/SearchFilter.vue';
import LeftClickOptionMenu from "@/components/Utilities/LeftClickOptionMenu.vue";
import { saveAs } from 'file-saver';

@Component({
    components: {
        SearchFilter,
        GarageDetails,
        LeftClickOptionMenu
    },
})
export default class GaragesSearch extends Vue {
    placeholder: string = "Ricerca per Codice PLI, P. IVA, Ragione Sociale, Località, Provincia";
    GARAGE_TYPES_SOURCE = "SIGNS_GARAGE_TYPES";
    dropDownGarageTypeList: DropDownItem [] = [];
    idGarageDetail: any = null;
    garageCodeSelected: string = null;
    freeText = null;
    showLoading: boolean = false;
    ready: boolean = false;
    firstSearch: boolean = false;
    resultsItems: any = {
        resultPage: new Array(),
        total: 0
    };
    page: number = 1;
    garageDetailEditMode: boolean = false;
    downloadReportInProgress: boolean = false;

    // advanced search
    advCodiceFl: string = null;
    advPiva: string = null;
    advCf: string = null;
    advRascl: string = null;
    advLocalita: string = null;
    advProvincia: string = null;
    advFlagBo: string = null;
    advGarageType: string = null;
    advFlagActive: string  = null;

    optionsGarageTypes: any = new Array();

    //pacchetto per menu tasto destro su dettaglio entita'
    leftClickOptionMenuUrl: string = "/signs/";
    leftClickOptionMenuUrlArgument: string = "codiceFl";
    handleClick (event, item) {
        (this.$refs.leftClickOptions as LeftClickOptionMenu).handleClick(event, item);
    }

    async mounted() {
        this.ready = true;
        await this.getDropDownGarageTypeList();
        this.optionsGarageTypes = this.setOptions(this.dropDownGarageTypeList);

        if (this.$route.params.id) {
            let app: any = this;
            let garageCode: string = this.$route.params.id;
            let promise = this.getGarageId(garageCode);                
            promise.then(function (val) {
                let garage: any = {
                    codiceFl: garageCode,
                    id: val
                };
                app.openGarage(garage, true);
            });
        }
    }

    filterSelected: boolean = false;

    checkFilterParameter(){
        if(this.AdvancedSearchFilled)
            this.filterSelected = true;
        else
            this.filterSelected = false;
    }

    get GarageTitle(): string {
        if(this.garageCodeSelected != null)
            return `Officina: ${this.garageCodeSelected}`;
        else
            return 'Crea una nuova officina';
    }

    CheckIsNullOrEmpty(text: string) {
        if (text == null) return true;
        if (text == '') return true;
        return false;
    }

    get AdvancedSearchFilled(): boolean {           
        if (!this.CheckIsNullOrEmpty(this.advCodiceFl)) return true;
        if (!this.CheckIsNullOrEmpty(this.advPiva)) return true;
        if (!this.CheckIsNullOrEmpty(this.advCf)) return true;
        if (!this.CheckIsNullOrEmpty(this.advRascl)) return true;
        if (!this.CheckIsNullOrEmpty(this.advLocalita)) return true;
        if (!this.CheckIsNullOrEmpty(this.advProvincia)) return true;
        if (!this.CheckIsNullOrEmpty(this.advGarageType)) return true;
        if (!this.CheckIsNullOrEmpty(this.advFlagBo)) return true;
        if (!this.CheckIsNullOrEmpty(this.advFlagActive)) return true;
        
        return false;
    }

    resetFilters() {
        this.advCodiceFl = null;
        this.advPiva = null;
        this.advCf = null;
        this.advRascl = null;
        this.advLocalita = null;
        this.advProvincia = null;
        this.advGarageType = null;
        this.advFlagBo = null;
        this.advFlagActive = null;
        this.filterSelected = false;
    }

    async postAddingGarage(code: string) {
        let app: any = this;
        let promise = this.getGarageId(code);                
        promise.then(function (val) {
            let garage: any = {
                codiceFl: code,
                id: val
            };
            app.openGarage(garage, false);
        });
    }

    async getDropDownGarageTypeList(){
        try{
            let response = await axios.get<DropDownItem[]>(
                General.GetApiUrl('/api/DropDownItem/GetDropDownItemsBySourceCode?codDropDownSource=' + this.GARAGE_TYPES_SOURCE),{
                responseType: "json",
                withCredentials: true
            });
        if(response.data)
            this.dropDownGarageTypeList = response.data;
        }catch(ex){
            General.HandleError(ex, this);
        }
    }

    setOptions(dropDownItems: DropDownItem[]) {
        let array: Array<any> = [];
    
        array.push({ value: null, text: "" });

    
        dropDownItems.forEach(function (el) {
        array.push({ value: el.idDropDownItem, text: el.itemText });
        });
        return array;
    }

    async getGarageId(garageCode: string) {
        let idGarage: string = null;

        try {
            let response = await axios({
                method: 'get',
                url: General.GetApiUrl('/api/sign/GetGarageByCodiceFl?codiceFl=' + garageCode),
                responseType: 'json',
                withCredentials: true
            });
            idGarage = response.data.id;
        } catch (error) {
            General.HandleError(error, this);
            
        }
        return idGarage;
    }

    openGarage(garage: any, forceOpen: boolean) {
        let newPath = '/signs/' + garage.codiceFl;
        if (!forceOpen && this.$route.path !== newPath) 
            this.$router.push(newPath);

        this.garageDetailEditMode = true;
        this.idGarageDetail = garage.id;
        this.garageCodeSelected = garage.codiceFl;
        this.$bvModal.show('garage-details-modal');
    }

    createGarage() {
        this.garageDetailEditMode = false;
        this.idGarageDetail = null;
        this.garageCodeSelected = null;
        this.$bvModal.show('garage-details-modal');
    }

    close() {
        this.$bvModal.hide('garage-details-modal');
    }
    
    resetSearch() {
        this.firstSearch = false;
        this.resultsItems.resultPage.splice(0);
        this.page = 1;
    }

    searchFilterSearchEvent(genericSearch: string) {
        if (genericSearch != null) 
            this.freeText = genericSearch;
        this.searchItems(true)
    }

    searchFilterResertEvent() {
        this.resetFilters()
    }

    async searchGaragesDo(start: boolean) {
        this.showLoading = true;
        if (start == true)
            this.resetSearch();
        try {
            let results: any = await axios({
                method: 'post',
                url: General.GetApiUrl('/api/sign/GetGaragesWithFilter'),
                data: {
                    FreeText: this.freeText,
                    CodiceFl: this.advCodiceFl,
                    Piva: this.advPiva,
                    Cf: this.advCf,
                    Rascl: this.advRascl,
                    Localita: this.advLocalita,
                    Provincia: this.advProvincia,
                    Tipologia: this.advGarageType,
                    FlagBo: this.advFlagBo,
                    FlagActive: this.advFlagActive,
                    CurrentPage: this.page
                },
                withCredentials: true,
                responseType: 'json'
            });
           
            this.resultsItems.resultPage = this.resultsItems.resultPage.concat(results.data.listPage);
            this.resultsItems.total = results.data.total;
             
            this.firstSearch = true;
            this.page += 1;
            
            this.showLoading = false;
        } catch (error) {
            General.HandleError(error, this);
            this.showLoading = false;
        }

    }

    searchItems(start: boolean) {
        this.searchGaragesDo(start);
    }

    async downloadExcelReport() {
        this.ready = false;
        this.downloadReportInProgress = true;
        try {
            let response = await axios({
                method: 'post',
                url: General.GetApiUrl("/api/sign/DownloadGaragesReport"),
                data: {
                    FreeText: this.freeText,
                    CodiceFl: this.advCodiceFl,
                    Piva: this.advPiva,
                    Cf: this.advCf,
                    Rascl: this.advRascl,
                    Localita: this.advLocalita,
                    Provincia: this.advProvincia,
                    Tipologia: this.advGarageType,
                    FlagBo: this.advFlagBo,
                    CurrentPage: this.page
                },
                withCredentials: true,
                responseType: 'blob'
            });
            let fileName = General.getFileNameFromHeader(response.headers);
            saveAs(new Blob([response.data]), fileName);                
        } catch (error) {
            General.showAlertDanger(error, this);
        } finally {
            this.ready = true;
            this.downloadReportInProgress = false;
        }
    }
}
